import { Component, Input } from '@angular/core';
import { Faq } from './shared/faqs.model';
@Component({
  selector: 'store-faqs',
  template: `
    <div class="va-faq" *ngFor="let faq of faq1; let i = index">
      <div class="question" (click)="toggleFaq(i)">
        <span>{{ faq.question }}</span>
        <mat-icon>{{ faqIcon(i) }}</mat-icon>
      </div>
      <span class="answer" [ngClass]="{ show: isFaqOpen(i) }" [innerHtml]="faq.answer | vaSanitize"></span>
    </div>
  `,
  styleUrls: ['./faqs.component.scss'],
  standalone: false,
})
export class VaFaqsComponent {
  @Input()
  set faqs(faqs: Faq[]) {
    const re = /Google My Business/gi;
    if (faqs) {
      this.faq1 = [];
      faqs.forEach((element) => {
        const faq: FAQLocal = new FAQLocal();
        faq.question = element.question.replace(re, 'Google Business Profile');
        faq.answer = element.answer.replace(re, 'Google Business Profile');
        this.faq1.push(faq);
      });
    }
  }
  openFaqs: number[] = [];
  faq1: FAQLocal[] = [];
  toggleFaq(index: number): void {
    if (this.openFaqs.indexOf(index) >= 0) {
      this.openFaqs.splice(this.openFaqs.indexOf(index), 1); // Remove
    } else {
      this.openFaqs.push(index); // Insert
    }
  }

  isFaqOpen(index: number): boolean {
    return this.openFaqs.indexOf(index) >= 0;
  }

  faqIcon(index: number): string {
    return this.isFaqOpen(index) ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
  }
}
export class FAQLocal {
  question: string;
  answer: string;
}
